var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.disabled && _vm.clientRoleOptions
    ? _c(
        "div",
        { staticClass: "input-field-container radio-container" },
        [
          _c("label", [_vm._v(" " + _vm._s(_vm.$tc("Role", 2)) + " ")]),
          _vm._v(" "),
          _c("v-combobox", {
            staticClass: "input-field",
            attrs: {
              value: _vm.selectedClientRoles,
              items: _vm.clientRoleOptions,
              "item-text": "label",
              multiple: "",
              "return-object": "",
              clearable: ""
            },
            on: { input: _vm.updateClientRolesPermissions },
            scopedSlots: _vm._u(
              [
                {
                  key: "item",
                  fn: function(ref) {
                    var item = ref.item
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c("permissions-client-role-item", {
                        attrs: {
                          "client-role": item,
                          "permissions-selected": _vm.permissionsSelected,
                          "client-roles-selected": _vm.selectedClientRoles
                        },
                        on: { selectClientRole: _vm.selectClientRole }
                      })
                    ]
                  }
                }
              ],
              null,
              false,
              930478257
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-500f588e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-500f588e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/Accounts/Permissions/PermissionsClientRole.vue
// module id = null
// module chunks = 